// extracted by mini-css-extract-plugin
export default {"wrapper":"NakedBanner-module__wrapper","time":"NakedBanner-module__time"};